export interface ISafeInEducation {
	barred?: boolean;
	barredCheckDate?: string;
	waiver?: boolean;
	ordersYou?: boolean;
	ordersChild?: boolean;
	cautioned?: boolean;
	safeInEducationDetails?: string;
	previousSafeguardingAllegations?: boolean;
	readKCSIE?: boolean;
	readKCSIEError?: string;
	prohibitedFromTeaching?: boolean;
	prohibitedFromTeachingError?: string;
	knownPolice?: boolean;
	knownPoliceError?: string;
	prohibitedFromManagement?: boolean;
	prohibitedFromManagementError?: string;
	criminalOffencesLaw?: boolean;
	criminalOffencesLawError?: string;
	barredError?: string;
	waiverError?: string;
	ordersYouError?: string;
	ordersChildError?: string;
	cautionedError?: string;
	safeInEducationDetailsError?: string;
	previousSafeguardingAllegationsError?: string;
	safeguardingQuestionaire?: ISafeguardingQuestionaire;
	violentOffence?: boolean;
	anotherCountry?: boolean;
	violentOffenceError?: string;
	anotherCountryError?: string;
	readChildcareAct?: boolean;
	readChildcareActError?: string;
}

export class SafeInEducationModel {
	barred?: boolean;
	barredCheckDate?: string;
	waiver?: boolean;
	ordersYou?: boolean;
	ordersChild?: boolean;
	cautioned?: boolean;
	safeInEducationDetails?: string;
	previousSafeguardingAllegations?: boolean;
	readKCSIE?: boolean;
	readKCSIEError?: string;
	prohibitedFromTeaching?: boolean;
	prohibitedFromTeachingError?: string;
	knownPolice?: boolean;
	knownPoliceError?: string;
	prohibitedFromManagement?: boolean;
	prohibitedFromManagementError?: string;
	criminalOffencesLaw?: boolean;
	criminalOffencesLawError?: string;
	barredError?: string;
	waiverError?: string;
	ordersYouError?: string;
	ordersChildError?: string;
	cautionedError?: string;
	safeInEducationDetailsError?: string;
	previousSafeguardingAllegationsError?: string;
	safeguardingQuestionaire?: ISafeguardingQuestionaire;
	violentOffence?: boolean;
	anotherCountry?: boolean;
	violentOffenceError?: string;
	anotherCountryError?: string;
	readChildcareAct?: boolean;
	readChildcareActError?: string;

	constructor(data: any = {}) {
		this.barred = data.barred !== null && data.barred !== undefined ? data.barred : null;
		this.barredCheckDate = data.barredCheckDate || null;
		this.waiver = data.waiver !== null && data.waiver !== undefined ? data.waiver : null;
		this.ordersYou = data.ordersYou !== null && data.ordersYou !== undefined ? data.ordersYou : null;
		this.ordersChild = data.ordersChild !== null && data.ordersChild !== undefined ? data.ordersChild : null;
		this.cautioned = data.cautioned !== null && data.cautioned !== undefined ? data.cautioned : null;
		this.violentOffence = data.violentOffence !== null && data.violentOffence !== undefined ? data.violentOffence : null;
		this.anotherCountry = data.anotherCountry !== null && data.anotherCountry !== undefined ? data.anotherCountry : null;
		this.previousSafeguardingAllegations = data.previousSafeguardingAllegations !== null && data.previousSafeguardingAllegations !== undefined ? data.previousSafeguardingAllegations : null;
		this.readKCSIE = data.readKCSIE !== null && data.readKCSIE !== undefined ? data.readKCSIE : null;
		this.prohibitedFromTeaching = data.prohibitedFromTeaching !== null && data.prohibitedFromTeaching !== undefined ? data.prohibitedFromTeaching : null;
		this.knownPolice = data.knownPolice !== null && data.knownPolice !== undefined ? data.knownPolice : null;
		this.prohibitedFromManagement = data.prohibitedFromManagement !== null && data.prohibitedFromManagement !== undefined ? data.prohibitedFromManagement : null;
		this.criminalOffencesLaw = data.criminalOffencesLaw !== null && data.criminalOffencesLaw !== undefined ? data.criminalOffencesLaw : null;
		this.safeInEducationDetails = data.safeInEducationDetails || "";
		this.safeguardingQuestionaire = data.safeguardingQuestionaire || null;
		this.readChildcareAct = data.readChildcareAct !== null && data.readChildcareAct !== undefined ? data.readChildcareAct : null;
	}
}

export interface ISafeguardingQuestionaire {
	primaryPurposeSafeguarding: number;
	typicallyResponsibleCoordinatingSafeguarding: number;
	signOfAbuse: number;
	studentDisclosesInformation: number;
	schoolsChildProtectionPolicy: number;
	fgmDefinition: number;
	keyPrincipleOnlineSafetyStudents: number;
	teachersConsiderRegardingSafeguarding: number;
	criminalBackgroundCheckTeachers: number;
	studentConfides: number;
}

export class SafeguardingQuestionaireModel implements ISafeguardingQuestionaire {
	primaryPurposeSafeguarding: number;
	typicallyResponsibleCoordinatingSafeguarding: number;
	signOfAbuse: number;
	studentDisclosesInformation: number;
	schoolsChildProtectionPolicy: number;
	fgmDefinition: number;
	keyPrincipleOnlineSafetyStudents: number;
	teachersConsiderRegardingSafeguarding: number;
	criminalBackgroundCheckTeachers: number;
	studentConfides: number;

	constructor(data?: ISafeguardingQuestionaire) {
		this.primaryPurposeSafeguarding = data?.primaryPurposeSafeguarding ?? null;
		this.typicallyResponsibleCoordinatingSafeguarding = data?.typicallyResponsibleCoordinatingSafeguarding ?? null;
		this.signOfAbuse = data?.signOfAbuse ?? null;
		this.studentDisclosesInformation = data?.studentDisclosesInformation ?? null;
		this.schoolsChildProtectionPolicy = data?.schoolsChildProtectionPolicy ?? null;
		this.fgmDefinition = data?.fgmDefinition ?? null;
		this.keyPrincipleOnlineSafetyStudents = data?.keyPrincipleOnlineSafetyStudents ?? null;
		this.teachersConsiderRegardingSafeguarding = data?.teachersConsiderRegardingSafeguarding ?? null;
		this.criminalBackgroundCheckTeachers = data?.criminalBackgroundCheckTeachers ?? null;
		this.studentConfides = data?.studentConfides ?? null;
	}
}

export interface ISafeguardingQuestionaireErrors {
	primaryPurposeSafeguardingError?: string;
	typicallyResponsibleCoordinatingSafeguardingError?: string;
	signOfAbuseError?: string;
	studentDisclosesInformationError?: string;
	schoolsChildProtectionPolicyError?: string;
	fgmDefinitionError?: string;
	keyPrincipleOnlineSafetyStudentsError?: string;
	teachersConsiderRegardingSafeguardingError?: string;
	criminalBackgroundCheckTeachersError?: string;
	studentConfidesError?: string;
}

export class SafeguardingQuestionaireErrorsModel implements ISafeguardingQuestionaireErrors {
	primaryPurposeSafeguardingError?: string;
	typicallyResponsibleCoordinatingSafeguardingError?: string;
	signOfAbuseError?: string;
	studentDisclosesInformationError?: string;
	schoolsChildProtectionPolicyError?: string;
	fgmDefinitionError?: string;
	keyPrincipleOnlineSafetyStudentsError?: string;
	teachersConsiderRegardingSafeguardingError?: string;
	criminalBackgroundCheckTeachersError?: string;
	studentConfidesError?: string;

	constructor(data?: ISafeguardingQuestionaireErrors) {
		this.primaryPurposeSafeguardingError = data?.primaryPurposeSafeguardingError ?? null;
		this.typicallyResponsibleCoordinatingSafeguardingError = data?.typicallyResponsibleCoordinatingSafeguardingError ?? null;
		this.signOfAbuseError = data?.signOfAbuseError ?? null;
		this.studentDisclosesInformationError = data?.studentDisclosesInformationError ?? null;
		this.schoolsChildProtectionPolicyError = data?.schoolsChildProtectionPolicyError ?? null;
		this.fgmDefinitionError = data?.fgmDefinitionError ?? null;
		this.keyPrincipleOnlineSafetyStudentsError = data?.keyPrincipleOnlineSafetyStudentsError ?? null;
		this.teachersConsiderRegardingSafeguardingError = data?.teachersConsiderRegardingSafeguardingError ?? null;
		this.criminalBackgroundCheckTeachersError = data?.criminalBackgroundCheckTeachersError ?? null;
		this.studentConfidesError = data?.studentConfidesError ?? null;
	}
}
